export const topTicker = [
  { time: '10:42', text: '旧料回顾 新开「2017 选秀季往事」档期，首批入档 9 条' },
  { time: '10:04', text: '翻旧账合集 追加「陆屿资本饭局」三阶段长尾线索' },
  { time: '09:37', text: '往期爆料存档 复核「林晚 解约风波」原文时间戳 2 处' },
  { time: '09:12', text: '历史黑料库 迁移旧版 2019 存档至新归档目录，内容不变' },
  { time: '08:47', text: '旧料回顾 新增「往年跨年舞台事故」主题包' },
];

export const heroStats = [
  { value: '2016', label: '最早入档年份' },
  { value: '2,140+', label: '已收录事件档' },
  { value: '87', label: '翻旧账专题在更' },
  { value: '4.6 万', label: '累计补齐线索条' },
];

export const quickEntries = [
  { key: '2025', label: '按年份翻旧档', icon: 'ri-calendar-todo-line' },
  { key: '2024', label: '按人物回溯', icon: 'ri-user-search-line' },
  { key: '2023', label: '按题材分拣', icon: 'ri-price-tag-3-line' },
  { key: '2022', label: '进翻旧账合集', icon: 'ri-folder-history-line' },
];

export type SpeedReport = {
  id: string;
  kind: '入档' | '补线索' | '复盘' | '旧料重检';
  title: string;
  excerpt: string;
  time: string;
  tags: string[];
};

export const speedReports: SpeedReport[] = [
  {
    id: 'sr-1',
    kind: '入档',
    title: '“魏屿 饭局旧照”补全第三视角供词',
    excerpt: '把当时无人认领的三张抓拍并进时间线，旁证从“听说”变成“可回看”。',
    time: '2026 · 09 · 05',
    tags: ['旧料回顾', '历史黑料'],
  },
  {
    id: 'sr-2',
    kind: '补线索',
    title: '阿梨“退圈前夜”新增两条时间戳',
    excerpt: '连夜对齐声明前后各一段原话，空档被一条 2019 年的采访填上。',
    time: '2026 · 09 · 05',
    tags: ['往期爆料', '过往大瓜'],
  },
  {
    id: 'sr-3',
    kind: '复盘',
    title: '童舟“代言滑铁卢”按日拆线完成',
    excerpt: '把整段从官宣到解约摊成 40 天明细，哪天发生了什么一眼可见。',
    time: '2026 · 09 · 04',
    tags: ['翻旧账', '旧料回顾'],
  },
  {
    id: 'sr-4',
    kind: '入档',
    title: '某联名系列“翻车始末”收回三期旧账',
    excerpt: '过往被折叠的三期正文今天一次性回档，结尾处标注缺档待补。',
    time: '2026 · 09 · 04',
    tags: ['历史黑料', '存档'],
  },
  {
    id: 'sr-5',
    kind: '旧料重检',
    title: 'Momo 事件 2019 聊天记录归档对齐',
    excerpt: '同一批记录里几处时间先后对不上，本次以原件页码为准重新排序。',
    time: '2026 · 09 · 03',
    tags: ['旧料回顾', '线索补齐'],
  },
  {
    id: 'sr-6',
    kind: '旧料重检',
    title: '苏黎“节目幕后”原始素材复核通过',
    excerpt: '逐条比对剪辑成片与原始母带，标定过的不再算孤证。',
    time: '2026 · 09 · 03',
    tags: ['过往大瓜', '复核'],
  },
];

export const timelineYears = [
  { year: '2026', label: '在更', count: 312 },
  { year: '2025', label: '密集', count: 406 },
  { year: '2024', label: '密集', count: 388 },
  { year: '2023', label: '中段', count: 270 },
  { year: '2022', label: '中段', count: 226 },
  { year: '2021', label: '疏', count: 158 },
  { year: '2020', label: '疏', count: 134 },
  { year: '2019', label: '归档', count: 96 },
];

export const timelineHighlights = [
  { time: '2019-11', event: '“饭局旧照”首次在网络铺开，当日无归档来源' },
  { time: '2021-03', event: '当事方发声，相关旧帖多数被隐藏下架' },
  { time: '2022-08', event: '翻旧账合集立项，启动跨平台线索回捞' },
  { time: '2024-01', event: '原声/原文时间戳全部对齐，补齐度升至 87%' },
  { time: '2026-06', event: '补入第三视角供词，事件线正式闭合成串' },
];

export type LongGossip = {
  id: string;
  title: string;
  range: string;
  stage: number;
  progress: number;
  excerpt: string;
  image: string;
  tags: string[];
  featured?: boolean;
};

export const longGossip: LongGossip[] = [
  {
    id: 'lg-1',
    title: '“陆屿 资本饭局”全案',
    range: '2019 — 2026',
    stage: 6,
    progress: 92,
    excerpt:
      '一条横跨七年的长线。从一张饭局旧照说起，中间几度断更，今年靠新补的旁证把整串接起来，是目前翻旧账合集里最完整的一档。',
    image:
      'https://readdy.ai/api/search-image?query=a%20single%20long%20winding%20paper%20timeline%20with%20many%20pinned%20dated%20paper%20labels%20stretched%20across%20a%20warm%20studio%20wall%2C%20red%20string%20connecting%20notes%2C%20archival%20investigation%20mood%20board%20aesthetic%2C%20warm%20cream%20background%2C%20ink%20black%20typography%20fragments%2C%20vermillion%20red%20pins%2C%20subtle%20film%20grain%2C%20editorial%20still%20life%2C%20photorealistic%2C%20high%20detail%2C%20uncluttered%20composition&width=1000&height=1180&seq=lg-card-1&orientation=portrait',
    tags: ['历史黑料', '长期瓜'],
    featured: true,
  },
  {
    id: 'lg-2',
    title: '林晚“解约风波”逐年档案',
    range: '2020 — 2025',
    stage: 4,
    progress: 76,
    excerpt:
      '合约条款、公开声明、解约后首访，三段被拆成年度单元，每条都带原发日期，方便对照哪年说过哪句。',
    image:
      'https://readdy.ai/api/search-image?query=stack%20of%20labeled%20manila%20archive%20folders%20fanned%20open%20on%20a%20warm%20wooden%20desk%2C%20papers%20with%20printed%20dates%20and%20red%20seal%20stamps%2C%20warm%20side%20lighting%2C%20archival%20document%20aesthetic%2C%20cream%20ink%20and%20muted%20vermillion%20red%20palette%2C%20film%20grain%2C%20high%20detail%20still%20life%2C%20photorealistic%2C%20quiet%20uncluttered%20composition&width=1000&height=1180&seq=lg-card-2&orientation=portrait',
    tags: ['往期爆料', '人物档'],
    featured: true,
  },
  {
    id: 'lg-3',
    title: '阿辰“人设重建记”',
    range: '2021 — 2026',
    stage: 3,
    progress: 64,
    excerpt:
      '从“翻红”到“再翻车”，中间三次改口都被原话钉在档案里。合集按人设节点分段，每段都留原文出处。',
    image:
      'https://readdy.ai/api/search-image?query=old%20printed%20newspaper%20pages%20and%20dated%20screenshots%20pinned%20and%20taped%20flat%20on%20warm%20paper%20desk%2C%20timestamps%20highlighted%20with%20amber%20and%20red%20marker%20circles%2C%20neutral%20documentary%20flat%20lay%2C%20archival%20evidence%20aesthetic%2C%20cream%20ink%20and%20warm%20tones%2C%20film%20grain%2C%20photorealistic%2C%20high%20detail&width=1000&height=1180&seq=lg-card-3&orientation=portrait',
    tags: ['翻旧账', '过往大瓜'],
    featured: true,
  },
];

export type OldReview = {
  id: string;
  title: string;
  year: string;
  category: string;
  excerpt: string;
  image: string;
};

export const oldReview: OldReview[] = [
  {
    id: 'or-1',
    title: '2016 街头募捐“摆拍疑云”',
    year: '2016',
    category: '舆情反转',
    excerpt: '当年被骂最凶的一段，如今回看补料，只剩两处疑点还在归档里悬着。',
    image:
      'https://readdy.ai/api/search-image?query=stack%20of%20old%20newspapers%20from%20different%20years%20on%20a%20warm%20newsstand%2C%20front%20pages%20rolled%20and%20dog-eared%2C%20warm%20window%20light%2C%20retro%20print%20archive%20feel%2C%20cream%20and%20ink%20tones%2C%20film%20grain%2C%20photorealistic%20still%20life%2C%20high%20detail&width=900&height=620&seq=old-review-1&orientation=landscape',
  },
  {
    id: 'or-2',
    title: '2019 “跨年舞台事故”全程',
    year: '2019',
    category: '现场还原',
    excerpt: '按秒表重排现场流程，谁的镜头切慢了、谁的话筒先没声，一清二楚。',
    image:
      'https://readdy.ai/api/search-image?query=vintage%20crt%20television%20on%20a%20sideboard%20broadcasting%20snowy%20static%20in%20a%20warm%20dim%20living%20room%2C%20retro%20media%20archive%20nostalgic%20feel%2C%20warm%20amber%20lamp%20light%2C%20cream%20ink%20and%20muted%20tones%2C%20film%20grain%2C%20photorealistic%20still%20life%2C%20high%20detail&width=900&height=620&seq=old-review-2&orientation=landscape',
  },
  {
    id: 'or-3',
    title: '“退圈宣言”前后反差合集',
    year: '2021',
    category: '言语对照',
    excerpt: '宣言那天说的话，和之前半年的采访放在一起，差在哪里一目了然。',
    image:
      'https://readdy.ai/api/search-image?query=long%20poster%20wall%20of%20old%20magazine%20covers%20behind%20glass%20in%20a%20warm%20archive%20room%2C%20muted%20faded%20covers%2C%20warm%20overhead%20light%2C%20retro%20editorial%20print%20feel%2C%20cream%20ink%20tones%2C%20film%20grain%2C%20photorealistic%20still%20life%2C%20high%20detail&width=900&height=620&seq=old-review-3&orientation=landscape',
  },
  {
    id: 'or-4',
    title: '2024 “联名翻车”三个月记',
    year: '2024',
    category: '事件拆线',
    excerpt: '从官宣到滑铁卢只隔 92 天，逐日明细补齐后成了最常用的复盘样板。',
    image:
      'https://readdy.ai/api/search-image?query=warm%20office%20desk%20covered%20in%20printed%20calendars%20and%20circled%20dates%20with%20red%20marker%2C%20correction%20tapes%20and%20sticky%20notes%2C%20archival%20event%20timeline%20reconstruction%2C%20warm%20lamp%20light%2C%20cream%20ink%20palette%2C%20film%20grain%2C%20photorealistic%20high%20detail&width=900&height=620&seq=old-review-4&orientation=landscape',
  },
];

export type PersonFile = {
  id: string;
  code: string;
  sector: string;
  activeYears: string;
  clueCount: number;
  completeness: number;
  tags: string[];
};

export const personFiles: PersonFile[] = [
  { id: 'pf-1', code: '档 · 019', sector: '演员 · 饭局旧照系', activeYears: '2019 — 2026', clueCount: 68, completeness: 92, tags: ['历史黑料', '三视角补全'] },
  { id: 'pf-2', code: '档 · 031', sector: '演员 · 解约系', activeYears: '2020 — 2025', clueCount: 41, completeness: 76, tags: ['往期爆料', '逐年档案'] },
  { id: 'pf-3', code: '档 · 047', sector: '歌手 · 退圈系', activeYears: '2019 — 2021', clueCount: 33, completeness: 84, tags: ['退圈', '原话对照'] },
  { id: 'pf-4', code: '档 · 058', sector: '网红 · 翻车系', activeYears: '2021 — 2026', clueCount: 52, completeness: 64, tags: ['翻旧账', '人设节点'] },
  { id: 'pf-5', code: '档 · 063', sector: '品牌 · 代言系', activeYears: '2023 — 2024', clueCount: 19, completeness: 88, tags: ['联名翻车', '拆线'] },
  { id: 'pf-6', code: '档 · 072', sector: '制作人 · 幕后系', activeYears: '2016 — 2022', clueCount: 27, completeness: 71, tags: ['旧料回顾', '母带复核'] },
];

export const downloadEntries = [
  { name: '历史黑料 · 完整索引', desc: '2026 第三季度全量事件目录', size: 'PDF · 28 页', icon: 'ri-file-list-3-line' },
  { name: '旧料回顾 · 排期表', desc: '往年事件按月的归档排期', size: 'CSV · 可筛选', icon: 'ri-table-2' },
  { name: '翻旧账合集 · 主题包', desc: '已结案长线的整包素材', size: 'ZIP · 480MB', icon: 'ri-archive-drawer-line' },
  { name: '线索补齐 · 校对底稿', desc: '供复核使用的时间戳清单', size: 'XLSX · 分卷', icon: 'ri-file-excel-2-line' },
];

export const sectionQuickLinks = [
  { label: '本期速报', href: '#speed' },
  { label: '往年档期', href: '#timeline' },
  { label: '长期瓜合集', href: '#longgossip' },
  { label: '旧料回顾', href: '#oldreview' },
  { label: '人物档', href: '#person' },
  { label: '入口与下载', href: '#download' },
];